import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Layout from "../../layout/Layout";
import {  useLeaves } from "./provider";

function Purches() {


  return <Layout><Outlet /></Layout>;
}

export default Purches;
